export default "__VITE_ASSET__C7m3WN9z__"